import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { keys } from 'lodash';

import { nodeIssues as nodeIssueActions } from '../actions';
import { nodeIssues as nodeIssueSelectors } from '../selectors';
import { nodeHealthPageReducer } from '../reducers';

import NodeHealthSummaryComponent from '../Components/NodeHealthSummaryComponent';

export class NodeHealthSummaryContainer extends React.Component {
  static propTypes = {
    activeIssueCountsLookup: PropTypes.object.isRequired,
    activeIssuesByNodeNameById: PropTypes.object.isRequired,
    issueTypesRowTitles: PropTypes.array.isRequired,
    nodesColumnTitles: PropTypes.array.isRequired,
    nodeIssueTypesById: PropTypes.object.isRequired,
    setNodeIssuesSelected: PropTypes.func.isRequired,
    sortedNode: PropTypes.string,
    onSelectorChange: PropTypes.func.isRequired,
    onSort: PropTypes.func.isRequired,
    onSearchChange: PropTypes.func.isRequired,
    searchTerm: PropTypes.string.isRequired
  }

  render() {
    return (
      <NodeHealthSummaryComponent
        activeIssuesByNodeNameById={this.props.activeIssuesByNodeNameById}
        activeIssueCountsLookup={this.props.activeIssueCountsLookup}
        issueTypesRowTitles={this.props.issueTypesRowTitles}
        nodesColumnTitles={this.props.nodesColumnTitles}
        nodeIssueTypesById={this.props.nodeIssueTypesById}
        sortedNode={this.props.sortedNode}
        onSelectionComplete={this.props.setNodeIssuesSelected}
        onSelectorChange={this.props.onSelectorChange}
        onSort={this.props.onSort}
        onSearchChange={this.props.onSearchChange}
        searchTerm={this.props.searchTerm}
      />
    );
  }
}
export const mapStateToProps = (state) => {
  const sortedNode = nodeHealthPageReducer.getNodeHealthSortedColumn(state);
  const activeIssuesByNodeNameById = nodeIssueSelectors.activeIssuesByNodeNameById(state);

  //get the default issue types' row titles
  let issueTypesRowTitles = keys(activeIssuesByNodeNameById) || [];

  const highestNumbersIssueTypeId = issueTypesRowTitles[0];
  const activeIssuesByNodeOfHighestIssueType =
   activeIssuesByNodeNameById[highestNumbersIssueTypeId] || {};

  const activeIssueCountsLookup = nodeIssueSelectors.activeIssueCountsLookup(state);
  //this prop could keep the nodes column titles fixed
  //not dynmically changed when sort issues by node
  const nodesColumnTitles = keys(activeIssuesByNodeOfHighestIssueType)
    .filter(nodeName => activeIssueCountsLookup[nodeName]);

  if (sortedNode)
  {
    const activeIssuesByIdSortByTypeNumbersDescByNode =
    nodeIssueSelectors.activeIssuesByIdSortByTypeNumbersDescByNode(state);
    const activeIssuesByTypeIdOfGivenNode =
     activeIssuesByIdSortByTypeNumbersDescByNode[sortedNode] || {};

    //When select a node to sort issues of the selected node,
    //the issue types' row titles will be updated according to the new sort
    const issueTypesRowTitlesOfGivenNode = keys(activeIssuesByTypeIdOfGivenNode);

    //The issue types which has 0 issues of the selected node.
    const difference =
    issueTypesRowTitles.filter(n => !issueTypesRowTitlesOfGivenNode.includes(n));
    issueTypesRowTitles = [...issueTypesRowTitlesOfGivenNode, ...difference];
  }

  const props = {
    activeIssueCountsLookup,
    activeIssuesByNodeNameById,
    issueTypesRowTitles,
    nodesColumnTitles,
    nodeIssueTypesById: nodeIssueSelectors.filteredNodeIssueTypesById(state),
    sortedNode,
    searchTerm: nodeHealthPageReducer.getNodeHealthPageSearch(state)
  };
  return props;
};

export const mapDispatchToProps = (dispatch) => {
  return {
    setNodeIssuesSelected: (selected) => {
      dispatch(nodeIssueActions.setNodeIssuesSelected(selected));
      dispatch(nodeIssueActions.setNodeIssuesSelectedForAck([]));
    },
    onSort: (sortingKey) => dispatch(nodeIssueActions.sortNodeIssueTable(sortingKey)),
    onSearchChange: (modelValue) => {
      dispatch(nodeIssueActions.setNodeIssueSearch(modelValue.searchterm));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NodeHealthSummaryContainer);


// WEBPACK FOOTER //
// src/Containers/NodeHealthSummaryContainer.jsx